<template>
  <!--subPage 상단 Navi-->
  <div class="sub_Navi">
    <ul>
      <li><a class="back" href="javascript:window.history.back();">뒤로</a></li>
      <li><h1>{{$t('mypage.checkVersion')}}</h1></li>
      <li class="linkBox"></li>
    </ul>
  </div>
  <!--//subPage 상단 Navi :End-->
  <!--subPage -->
  <div class="subPage_container">
    <div class="version_wrap">
      <h2>{{$t('mypage.alertVersion')}}</h2>
      <p class="info">{{$t('mypage.latestUpdate')}} : <span>ver 1.5</span></p>
      <p class="info">{{$t('mypage.updateDate')}} : <span>2024.02.29</span></p>
      <div class="download_box">
        <a class="down1">
          <p>{{$t('mypage.downloadAndroid')}}</p>
        </a>
        <a class="down2">
          <p>{{$t('mypage.downloadiPHONE')}}</p>
        </a>
      </div>
    </div>
  </div>
  <!--//subPage_container :End -->
  <!--//subPage :End -->
</template>

<script>
export default {
  name: "ConfirmVer",
};
</script>
